/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITIALSTATE = { results: {} };

const permitValidations = (state = INITIALSTATE, action) => {
    if (action.type === types.SET_VALIDATION_ERROR) {
        const st = { ...state };
        const { path, error } = action.payload;

        delete st.results[path];
        if (error) {
            st.results[path] = error;
        }
        return st;
    }
    // PR#9675 removed 'default' implementation that caught any action with payload.error
    return state;
};

export default permitValidations;
